import { render, staticRenderFns } from "./PearsonPlusCarousel.vue?vue&type=template&id=184fecd8&scoped=true&"
import script from "./PearsonPlusCarousel.vue?vue&type=script&lang=js&"
export * from "./PearsonPlusCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PearsonPlusCarousel.vue?vue&type=style&index=0&id=184fecd8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184fecd8",
  null
  
)

export default component.exports